export const COMPONENT_NAME_FEATURE = 'Feature';
export const INACTIVE = 0;
